<template>
  <div class="what-kind-of-work-step">
    <h1 class="global-h1 what-kind-of-work-step__title">Select a message template</h1>

    <div class="what-kind-of-work-step__divider" style="margin-bottom: 25px"></div>

    <NoteWithIcon size="tiny" color="green" style="margin-bottom: 20px">
      <template #text>Next, we'll help craft an initial message to the creator to propose the collab.</template>
    </NoteWithIcon>

    <Loader v-if="newCustomCollabWizardStore.isLoadingTemplates" />
    <template v-else>
      <div v-if="isErrorNotesVisible" class="global-error-string" style="margin-bottom: 20px">Please select a collab type</div>

      <div class="what-kind-of-work-step__work-types-list">
        <label class="what-kind-of-work-step__work-type-snippet-wrap" v-for="collabTemplate in newCustomCollabWizardStore.customCollabTemplatesList" :key="collabTemplate.title">
          <CollabTypeSnippet
            :class="{
              'what-kind-of-work-step__work-type-snippet': true,
              'what-kind-of-work-step__work-type-snippet--selected': newCustomCollabWizardStore.selectedTemplateId === collabTemplate.templateId,
            }"
            :icon="collabTemplate.icon"
            :title="collabTemplate.title"
            :subTitle="collabTemplate.description"
            :ctaButtonText="newCustomCollabWizardStore.selectedTemplateId === collabTemplate.templateId ? 'Chosen' : 'Choose'"
            ctaButtonIcon="empty"
            :ctaButtonMinWidth="120"
          >
            <input type="radio" name="templateId" style="width: 20px; height: 20px; margin-right: 10px" :value="collabTemplate.templateId" v-model="newCustomCollabWizardStore.selectedTemplateId" />
          </CollabTypeSnippet>
        </label>
      </div>
      <div v-if="isErrorNotesVisible" class="global-error-string" style="margin-bottom: 24px">Please select a collab type</div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref, nextTick, watch } from "vue";

// Components
import NoteWithIcon from "@components/NoteWithIcon.vue";
import CollabTypeSnippet from "@components/collabSnippets/CollabTypeSnippet.vue";
import Loader from "@components/Loader/Loader.vue";

// Stores
import { useNewCustomCollabWizardStore } from "@stores/newCustomCollabWizardStore";
const newCustomCollabWizardStore = useNewCustomCollabWizardStore();

const emit = defineEmits<{
  (e: "selectTemplate"): void;
}>();

// Toggle error notes =========================================================
const isErrorNotesVisible = ref<boolean>(false);

// Emit event on template selection ===========================================
watch(
  () => newCustomCollabWizardStore.selectedTemplateId,
  () => emit("selectTemplate")
);

// Define expose ==============================================================
defineExpose({
  showValidationErrorNotes: () => (isErrorNotesVisible.value = true),
});
</script>

<style scoped lang="scss">
// Work type snippet ==========================================================
.work-type-snippet {
  padding: 16px 25px 16px 25px;
  border: 1px rgba(0, 0, 0, 0.15) solid;
  border-radius: 6px;

  &__icon-and-text {
  }

  &__icon {
  }

  &__text-wrap {
  }

  &__title {
  }

  &__subtitle {
  }

  &__cta-button {
  }
}

// "What kind of work" step ===================================================
.what-kind-of-work-step {
  &__title {
    margin-bottom: 20px;
  }

  &__divider {
    margin-bottom: 30px;
    border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
  }

  &__work-types-list {
    gap: 17px;
    padding: 0;
    margin: 0 0 33px;
    display: flex;
    flex-direction: column;
    list-style: none;
  }

  &__work-type-snippet-wrap {
    display: flex;
  }

  &__work-type-snippet {
    width: 100%;

    &--selected {
      border-color: rgba(0, 0, 0, 0) !important;
      background: rgba(0, 0, 0, 0.07) !important;
      pointer-events: none;

      :deep(.collab-type-snippet__cta-button) {
        opacity: 0.5;
      }
    }

    :deep(.collab-type-snippet__title) {
      text-decoration-style: dashed !important;
    }
  }

  &__note {
  }
}
</style>
